/* lrc-pdp.js — Formulary PDP accordion behaviour
   Accessible: aria-expanded toggled on both the wrapper and the
   trigger button. Keyboard works natively because the trigger is
   a real <button>. Idempotent + defer-safe. */
(function () {
  function init() {
    var triggers = document.querySelectorAll('.lrc-faq__trigger');
    if (!triggers.length) return;

    triggers.forEach(function (btn) {
      if (btn.dataset.lrcBound === 'true') return;
      btn.dataset.lrcBound = 'true';

      btn.addEventListener('click', function () {
        var item = btn.closest('.lrc-faq__item');
        var open = item.getAttribute('aria-expanded') === 'true';

        // Collapse every item (single-open accordion)
        document.querySelectorAll('.lrc-faq__item').forEach(function (i) {
          i.setAttribute('aria-expanded', 'false');
          var t = i.querySelector('.lrc-faq__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        // Open the clicked item if it was previously closed
        if (!open) {
          item.setAttribute('aria-expanded', 'true');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
